import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'flamingo-input-dialog',
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    
    <mat-dialog-content fxLayout="column">
      <p>{{ data.description }}</p>
      <mat-form-field fxFlex>
        <input matInput #inputValue [type]="data.inputType" [placeholder]="data.inputPlaceholder" />
      </mat-form-field>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        <span>{{ data.actionCancel }}</span>
      </button>
      
      <button mat-button [mat-dialog-close]="inputValue.value" color="accent">
        <span>{{ data.actionConfirm }}</span>
      </button>
    </mat-dialog-actions>
  `,
})
export class FlamingoInputDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: FlamingoInputDialogModel) {}
}

export interface FlamingoInputDialogModel {
  title: string;
  description: string;
  inputPlaceholder: string;
  inputType: string;
  actionConfirm: string;
  actionCancel: string;
}
